import React, {Component} from 'react';

/** Read-only data-elements table (editing is graph-view-only). */
class ElementsTable extends Component {
  render() {
    const {rows} = this.props;

    return (
      <div className="lt-section">
        <div className="lt-section-header">
          <span className="lt-section-title">Data Elements</span>
        </div>
        <table className="data-table lt-table">
          <thead>
            <tr>
              <th>Node</th>
              <th>Table</th>
              <th>Element</th>
              <th>Type</th>
              <th>CDE</th>
              <th>DD Column</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={6} className="lt-empty-row">No elements.</td></tr>
            )}
            {rows.map((el) => (
              <tr key={el._key} data-testid={`lt-el-row-${el.id}`}>
                <td>{el.nodeLabel}</td>
                <td>{el.tableName || '—'}</td>
                <td>{el.displayName || el.name || '—'}</td>
                <td>{el.dataType || '—'}</td>
                <td>{el.isCde ? '✓' : ''}</td>
                <td>{el.columnName || (el.columnId ? '(linked)' : '—')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ElementsTable;
